<template>
  <WidgetBaseCard
    :error="!!error"
    :loading="loading"
    :lastUpdate="lastUpdate"
    @click:refresh="refresh"
    @click:table="showTable"
  >
    <template #title>
      {{ $t("widgets.promotion.title") }}
    </template>

    <template v-if="data" #content>
      <div class="d-flex justify-center align-center h-100">
        <KpiMain :value="data.main.value" @click="onMainKpiClick"></KpiMain>
      </div>
    </template>
  </WidgetBaseCard>
</template>
<script>
import { inject } from "vue-demi";

import WidgetBaseCard from "./WidgetBaseCard.vue";
import KpiMain from "./WidgetKpiCard/KpiMain.vue";

import { useWidgetApi } from "@/composables/api/widget";
import { useRouter } from "@/composables/router";

export default {
  components: { KpiMain, WidgetBaseCard },

  setup() {
    const { data, lastUpdate, loading, error, refresh } = useWidgetApi(
      "/dashboard/promotion"
    );

    const router = useRouter();

    const showTable = () => {
      router.push({ name: "DashboardTable", query: { measure: "promotion" } });
    };

    const showOnMap = inject("showOnMap");

    const onMainKpiClick = () => {
      showOnMap({
        measure: "promotion"
      });
    };

    return {
      data,
      error,
      loading,
      lastUpdate,

      refresh,
      showTable,
      onMainKpiClick
    };
  }
};
</script>
<style></style>
